var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "30px",
    viewBox: "0 0 33 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-443.000000, -107.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(443.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6285853,25.294244 C33.6860746,27.1334261 32.3586843,29.4324324 30.2465703,29.4324324 L2.75310939,29.4324324 C0.636927702,29.4324324 -0.68433234,27.129862 0.371094444,25.294244 L14.1179968,1.37878326 C15.1760017,-0.461261114 17.8259124,-0.457926971 18.8820267,1.37878326 L32.6285853,25.294244 Z M16.5000117,20.3497678 C15.0445174,20.3497678 13.8645958,21.5336759 13.8645958,22.9940879 C13.8645958,24.4544999 15.0445174,25.638408 16.5000117,25.638408 C17.9555061,25.638408 19.1354277,24.4544999 19.1354277,22.9940879 C19.1354277,21.5336759 17.9555061,20.3497678 16.5000117,20.3497678 Z M13.9979135,10.8448168 L14.422903,18.6628066 C14.4427832,19.0286425 14.7442518,19.3150339 15.1093715,19.3150339 L17.890652,19.3150339 C18.2557717,19.3150339 18.5572403,19.0286425 18.5771205,18.6628066 L19.00211,10.8448168 C19.0235944,10.4496634 18.7100372,10.1173988 18.3156414,10.1173988 L14.6843248,10.1173988 C14.289929,10.1173988 13.9764291,10.4496634 13.9979135,10.8448168 L13.9979135,10.8448168 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.d0ab88795b94f3138c08012008e79bb7.svg";
export { ForwardRef as ReactComponent };